import { action } from 'nanostores'
import { $cart } from './stores'

export const setCart = action($cart, 'setCart', (store, updatedCart) => {
  store.set(updatedCart)
  return updatedCart
})
